/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartShippingTooltip_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartNoShipping_item$ref: FragmentReference;
export type CartNoShipping_item = {|
  +$fragmentRefs: CartShippingTooltip_item$ref,
  +$refType: CartNoShipping_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartNoShipping_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartShippingTooltip_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '62c32da5b378d99775f6e6d4d8dad429';
module.exports = node;
